<template>
  <div class="calendarRT">
    <div class="calendarRT__row">
      <div class="calendarRT__label">
        <div class="calendarRT__labelGroup">
          <div class="calendarRT__labelName">{{ $t('departure') }}</div>
          <i class="fas fa-chevron-right ml-2"></i>
        </div>
        <div class="calendarRT__labelGroup">
          <div class="calendarRT__labelName">{{ $t('return') }}</div>
          <i class="fas fa-chevron-down ml-2"></i>
        </div>
      </div>
      <div class="calendarRT__weekGroup --departure" v-for="(departureDay, departureIndex) in 7" :key="`${departureDay}departureHead`">
        <div class="calendarRT__date">
          <div class="calendarRT__month">
            <div class="calendarRT__monthDay">{{ getDay(data[departureIndex][0].going) }}</div>
            <div class="calendarRT__monthName">{{ getMonthName(data[departureIndex][0].going) }}</div>
          </div>
          <div class="calendarRT__dateName">{{ getDayName(data[departureIndex][0].going) }}</div>
        </div>
      </div>
    </div>
    <div class="calendarRT__row">
      <div class="calendarRT__weekGroup --return" >
        <div class="calendarRT__date"  v-for="(returnDay, returnIndex) in 7" :key="`${returnDay}returnHead`">
          <div class="calendarRT__month">
            <div class="calendarRT__monthDay">{{ getDay(data[0][returnIndex].return) }}</div>
            <div class="calendarRT__monthName">{{ getMonthName(data[0][returnIndex].return) }}</div>
          </div>
          <div class="calendarRT__dateName">{{ getDayName(data[0][returnIndex].return) }}</div>
        </div>
      </div>
      <div class="calendarRT__grid">
        <div class="calendarRT__gridRow" v-for="(rowValue, rowIndex) in 7" :key="`${rowValue}row`">
          <div class="calendarRT__gridRow" v-for="(colValue, colIndex) in 7" :key="`${colValue}col`">
            <dateFare
              :date="data[colIndex][rowIndex]"
              :isEnabled="isDatesEnabled(data[colIndex][rowIndex])"
              :classes="resolveClasses(data[colIndex][rowIndex], colIndex, rowIndex)"
              @select="sendDates(colIndex, rowIndex)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import dateFare from './dateFare'

export default {
  name: 'calendarRT',
  components: {
    dateFare
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    enabledDates: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data () {
    return {
      selected_x: 3,
      selected_y: 3
    }
  },
  beforeMount () {
    for (let y = 0; y < 7; y++) {
      for (let x = 0; x < 7; x++) {
        if (this.data[x][y].selected) {
          this.selected_x = x
          this.selected_y = y
        }
      }
    }
  },
  methods: {
    resolveClasses (date, colIndex, rowIndex) {
      let classes = {
        '--disabled': !this.isDatesEnabled(date) || !this.data[colIndex][rowIndex].amount,
        '--active': this.data[colIndex][rowIndex].selected,
        '--lower': (
          !this.data[colIndex][rowIndex].selected &&
          this.data[colIndex][rowIndex].best_price &&
          this.data[colIndex][rowIndex].amount
        )
      }
      return classes
    },
    isDatesEnabled (data) {
      return this.enabledDates.ow.includes(data['going']) && this.enabledDates.rt.includes(data['return']);
    },
    convertDateI18n (date) {
      let momentDate = moment(date, ['YYYY-MM-DD'])
      let day = momentDate.format('DD')
      let month = momentDate.format('MMM')
      month = month[0].toUpperCase() + month.substr(1)
      return this.locale === 'es' ? `${day} ${month}` : `${month} ${day}`
    },
    getDay (date) {
      let momentDate = moment(date, ['YYYY-MM-DD'])
      let day = momentDate.format('DD')
      return day
    },
    getMonthName (date) {
      let momentDate = moment(date, ['YYYY-MM-DD'])
      let month = momentDate.format('MMM')
      month = month[0].toUpperCase() + month.substr(1)
      return month
    },
    getDayName (date) {
      let momentDate = moment(date, ['YYYY-MM-DD'])
      let day = momentDate.locale(this.$store.getters.getLanguage).format('ddd')
      return day
    },
    sendDates (x, y) {
      for (let y = 0; y < 7; y++) {
        for (let x = 0; x < 7; x++) {
          if (this.data[x][y].selected) {
            this.data[x][y].selected = false
          }
        }
      }
      //this.data[this.selected_x][this.selected_y].selected = false
      this.selected_x = x
      this.selected_y = y
      this.data[x][y].selected = true
      this.$emit('changeDate', this.selected_x, this.selected_y)
    }
  }
}
</script>

<style lang="sass">
.calendarRT
  display: flex
  flex-direction: column
  width: 100%
  &__row
    display: flex
  &__week
    &Group
      display: flex
      background-color: var(--color-overlay-05)
      &.--departure
        width: 100%
      &.--return
        flex-direction: column
        min-width: 110px
  &__date
    flex: 1
    padding: .5rem
    box-shadow: 0 0 0 1px var(--color-overlay-10)
    &.--active
      box-shadow: inset 0 -2px 0 0 var(--color-primary)
    &Name
      font-size: var(--font-size-sm)
      width: 100%
      text-align: center
  &__grid
    display: flex
    width: 100%
    flex-direction: column
    &Row
      display: flex
      width: 100%
      height: 100%
  &__month
    display: flex
    font-weight: bold
    align-items: baseline
    justify-content: center
    &Day
      font-size: var(--font-size-base)
      margin: 0 .25rem 0 0
    &Name
      text-transform: uppercase
      font-size: var(--font-size-sm)
  &__label
    min-width: 110px
    font-size: var(--font-size-xs)
    font-weight: bold
    text-transform: uppercase
    display: flex
    flex-direction: column
    &Group
      display: flex
      width: 100%
      justify-content: center
      align-items: center
      flex: 1
      background-color: var(--color-overlay-05)
</style>
